import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {RemoteGetAdditionalCoverage} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {ExternalLinkPoint} from 'main/factories/usecases/endpoints';

export const makeGetAdditionalCoverage = () =>
	new RemoteGetAdditionalCoverage(
		makeBFFApiUrl(ExternalLinkPoint.additionalCoverage),
		makeAuthorizeHttpClientDecorator(),
	);
